import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { RadioButton } from '@telialt/common-radio-button/src';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const RentPlanSelectorSection = styled.section`
    position: relative;
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
`;
export const Title = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const Radio = styled(RadioButton)`
    & ~ & {
        margin-top: ${getPurpurSpacing('300')};
    }
`;
export const RadioLabel = styled.span`
    display: grid;
    grid-template-areas:
        'period oldPrice'
        'period monthlyPrice'
        'residualTag residualPrice';
    justify-content: space-between;
    font-size: ${getPurpurTypography('scale75')};
`;
export const Period = styled.span`
    grid-area: period;
    align-self: end;
`;
export const MonthlyPrice = styled.span<{ $highlighted: boolean }>`
    grid-area: monthlyPrice;
    font-weight: ${getPurpurTypography('weightBold')};
    color: ${({ $highlighted }) => ($highlighted ? getPurpurColor('red600') : 'inherit')};
`;
export const ResidualTag = styled.span`
    grid-area: residualTag;
    color: ${getPurpurColor('textMedium')};
`;
export const ResidualPrice = styled.span`
    grid-area: residualPrice;
    color: ${getPurpurColor('textMedium')};
`;
export const OldPrice = styled.span`
    grid-area: oldPrice;
    font-size: ${getPurpurTypography('scale50')};
    text-decoration: line-through;
    color: ${getPurpurColor('textWeak')};
`;
